export enum Currency {
    UAH = 1,
    USD = 2,
    EUR = 3,
}
